module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_77.ecd4761b.jpg";